import React from 'react';

const Shield = ({ width = '1.2rem', height = '1.2rem', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15.635 18.935"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      transform="translate(-325.091 -4661)"
      d="M326.267,4661H339.55a1.184,1.184,0,0,1,1.176,1.184v4.938a14.405,14.405,0,0,1-7.632,12.765.385.385,0,0,1-.37,0,14.4,14.4,0,0,1-7.633-12.765v-4.938A1.183,1.183,0,0,1,326.267,4661Zm5.695,11.558,5.6-5.294a.777.777,0,0,0,.226-.75.788.788,0,0,0-.543-.576.8.8,0,0,0-.768.182l-5.045,4.757-1.327-1.341a.787.787,0,0,0-1.332.339.8.8,0,0,0,.211.773l1.872,1.885A.791.791,0,0,0,331.962,4672.558Z"
    />
  </svg>
);

export default Shield;
